export const vertexShader = `
  uniform float uShapeCount;
  uniform vec3 uColor;

  attribute float shapeIndex;
  attribute float ratio;
  attribute vec3 color;

  varying vec2 vUv;
  varying float vDepth;
  varying float vDiscard;
  varying vec3 vColor;

  vec3 mixWhite(vec3 color, float amount) {
    return mix(color, vec3(1.0), amount);
  }

  void main() {
    vDiscard = shapeIndex == -1.0 ? 1.0 : 0.0;

    if (vDiscard == 1.0) {
      return;
    }

    float shapeWidth = 1.0 / uShapeCount;
    float offset = shapeIndex * shapeWidth;
    vUv = vec2(uv.x * shapeWidth + offset, uv.y);

    vec3 modelPosition = position;
    vec4 instancePosition = instanceMatrix * vec4(modelPosition, 1.0);
    vec4 mvPosition = modelViewMatrix * instancePosition;
    gl_Position = projectionMatrix * mvPosition;

    float amount = smoothstep(.5, .01, ratio * 300.); // boosting lines

    vColor = mixWhite(color, amount);
    vDepth = abs(mvPosition.z);
  }
`;

export const fragmentShader = `
  uniform sampler2D uMap;
  uniform float uShapeCount;

  varying vec2 vUv;
  varying float vDepth;
  varying float vDiscard;
  varying vec3 vColor;

  void main() {
    if (vDiscard == 1.0) discard;

    vec4 tColor = texture2D(uMap, vUv);
    if (tColor.a < 0.5) discard;

    gl_FragColor = vec4(vColor, tColor.a);

    // fog
    // gl_FragColor.a *= smoothstep(1000.0, 100.0, vDepth);
  }
`;
